export class CustomField {
  public _id:String;
  public name: string;
  public fieldType: 1 | 2|null;
  public description: String;
  public isRequired: Boolean;
  public organization: string;
  public createdBy: string;
  public createdOn: string;
  public isVisible:Boolean;
  public default:string;
  public clear(){
    this._id="";
    this.name="";
    this.fieldType=null;
    this.description="";
    this.isRequired=false;
    this.isVisible=false;
    this.default="";
  }
  public set(model:any){
    this._id=model._id;
    this.name=model.name;
    this.fieldType=model.fieldType;
    this.description=model.description;
    this.isRequired=model.isRequired;
    this.isVisible=model.isVisible;
    this.default=model.default;
  }
}
